.container {
  display: flex;
  font-size: 1em;
  margin: 1em 0;

  @media print {
    display: block;
  }
}

.section {
  page-break-inside: avoid;
}

.left {
  flex: 0 0 30%;
}

.right {
  flex-grow: 1;
  padding-left: 1em;
}

@media (max-width: 48em) {
  .container {
    display: block;
  }

  .right {
    padding-left: 0;
  }

  .chart {
    width: 100%;
  }
}
